import { createSlice } from "@reduxjs/toolkit";
import * as cityActions from "./cityActions";

const InitialState = {
    isLoading: false,
    city: [],
    hasError: false,
};

const cityReducer = createSlice({
    name: "city",
    initialState: InitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(cityActions.getCity.pending, (state) => {
                state.isLoading = true;
                state.hasError = false;
            })
            .addCase(cityActions.getCity.fulfilled, (state, action) => {
                state.city = action.payload;
                state.isLoading = false;
                state.hasError = false;
            })
            .addCase(cityActions.getCity.rejected, (state) => {
                state.hasError = true;
                state.isLoading = false;
            })
    },
});

export default cityReducer.reducer;